var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn)?_c('v-bottom-navigation',{staticClass:"hidden-sm-and-up",attrs:{"value":_vm.value,"color":"primary","app":""}},_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.text,attrs:{"to":link.route}},[_c('span',[_vm._v(_vm._s(link.text))]),_c('v-icon',[_vm._v(_vm._s(link.icon))])],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }